// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import LinkTextStyle from '@tcp/core/src/components/common/molecules/LinkText/LinkText.style';

export default css`
  ${LinkTextStyle}

  .background-link {
    @media ${(props) => props.theme.mediaQuery.medium} {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .link-text {
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin-bottom: 0;
      margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
    }
  }
`;

const StyledContainer = styled.div`
  position: relative;
  width: 100%;
  .module-countdown-img-full-width {
    width: 100%;
    height: 200px;
  }
`;

const StyledTextContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  ${(props) =>
    props.isImageView
      ? `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 95%;
  `
      : ``}

  .countdown-header-text-line {
    margin: 0;
  }
`;

const StyledTimerContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const StyledBackgroundWithColor = styled.div`
  background-color: ${(props) => props.color.color};
  padding: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
  display: flex;
  justify-content: center;
`;

const getStyle = (props, variant) => {
  const { styleOverrides: { cdBgColor, cdNumColor, cdTextColor, cdFs } = {} } = props;
  switch (variant) {
    case 'background':
      return `${!isEmpty(cdBgColor) ? `background:${cdBgColor?.backgroundColor}` : ''};`;
    case 'numColor':
      return `${cdNumColor?.color || props.theme.colors.WHITE};`;
    case 'textColor':
      return `${cdTextColor?.color || props.theme.colors.WHITE};`;
    case 'fontSize':
      return `${!isEmpty(cdFs) ? `font-size: ${cdFs?.fontSize}` : ''}`;
    default:
      return ``;
  }
};

const StyledNumberPart = styled.span`
  ${(props) => getStyle(props, 'background')};
  color: ${(props) => getStyle(props, 'numColor')};
  ${(props) => getStyle(props, 'fontSize')};
  padding-left: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
  padding-right: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
  ${(props) => props.customStyle || ''}
`;

const StyledTextPart = styled.span`
  ${(props) => getStyle(props, 'fontSize')};
  color: ${(props) => getStyle(props, 'textColor')};
  padding-right: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
  ${(props) => props.customStyle || ''}
`;

export {
  StyledContainer,
  StyledTextContainer,
  StyledTimerContainer,
  StyledBackgroundWithColor,
  StyledNumberPart,
  StyledTextPart,
};
